// @flow

import React from 'react';
import _ from 'lodash/fp';
import SelectFormInput from '../SelectFormInput/SelectFormInput';

export type Props = {
  apartment: Object,
  apartmentId: Object,
  projectId: Object,
  apartments: Object,
  projects: any[],
  disabled: boolean,
  change: Function,
};

const OrderApartmentInput = ({
  apartment,
  apartmentId,
  projectId,
  apartments,
  projects,
  disabled,
  change: onChange,
}: Props) => {
  let apartmentList = [];
  if (!!projectId.input.value) {
    apartmentList = apartments[projectId.input.value] || [];
    if (!!apartment.input.value) {
      apartmentList = [
        ...apartmentList,
        apartment.input.value,
      ];
    }
  }

  let projectList = projects;
  if (!!apartment.input.value && !!apartment.input.value.project) {
    projectList = [
      ...projectList,
      apartment.input.value.project,
    ];
  }

  return (
    <div>
      <SelectFormInput
        input={{
          value: projectId.input.value || null,
          onBlur: _.noop,
          onChange: project => {
            projectId.input.onChange(project ? project.id : null);
            if (!!apartmentId.input.value) {
              apartmentId.input.onChange(null);
            }

            if (onChange) {
              onChange();
            }
          },
        }}
        disabled={!!disabled}
        label="Projekt"
        meta={projectId.meta}
        valueKey="id"
        labelKey="name"
        options={projectList} />
      <SelectFormInput
        input={{
          value: apartmentId.input.value || null,
          onBlur: apartment => apartmentId.input.onBlur(apartment ? apartment.id : null),
          onChange: apartment => {
            apartmentId.input.onChange(apartment ? apartment.id : null);

            if (onChange) {
              onChange();
            }
          },
        }}
        disabled={!!disabled || !projectId.input.value}
        label="Lägenhet"
        meta={apartmentId.meta}
        valueKey="id"
        labelKey="objectId"
        options={apartmentList} />
    </div>
  );
};

export default OrderApartmentInput;



// WEBPACK FOOTER //
// ./src/components/OrderApartmentInput/OrderApartmentInput.js